import React, { useState, useEffect } from "react";
import LeftSection from "../../component/dashboard-section/panels/left-panel";
import RightSection from "../../component/dashboard-section/panels/right-panel";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hasValidLoginCredentials } from "../../utils/storageUtils";
import MyLoader from "../../component/reusebale/MyLoader";
const Dashboard = () => {
  const [activeComponent, setActiveComponent] = useState("Home");
  const [pendingLandlordsView, setPendingLandlordsView] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get login state from Redux
  const { loginSuccess } = useSelector((state) => state.auth);

  // Check authentication state on component mount and when loginSuccess changes
  useEffect(() => {
    const checkAuthState = () => {
      // Check both Redux state and localStorage
      const hasValidLocalStorage = hasValidLoginCredentials();
      const hasReduxLoginData =
        loginSuccess !== null && loginSuccess !== undefined;

      // If neither Redux state nor localStorage has valid auth data, redirect to login
      if (!hasValidLocalStorage && !hasReduxLoginData) {
        console.log("No valid authentication found, redirecting to login...");
        navigate("/login", { replace: true });
        return;
      }

      // If localStorage is valid but Redux state is empty, try to hydrate state
      if (hasValidLocalStorage && !hasReduxLoginData) {
        console.log("Valid localStorage found, hydrating Redux state...");
        dispatch(AuthAction.HydrateStateAction());
      }

      // Authentication check complete
      setIsCheckingAuth(false);
    };

    checkAuthState();
  }, [loginSuccess, navigate, dispatch]);

  // Show loading state while checking authentication
  if (isCheckingAuth) {
    return (
      <div className="flex h-screen justify-center items-center">
        <MyLoader />
      </div>
    );
  }

  // Only render dashboard if we have valid authentication
  const hasValidLocalStorage = hasValidLoginCredentials();
  const hasReduxLoginData = loginSuccess !== null && loginSuccess !== undefined;

  if (!hasValidLocalStorage && !hasReduxLoginData) {
    return null; // Will redirect via useEffect
  }

  const handleItemClick = (componentName) => {
    if (componentName === "Logout") {
      dispatch(AuthAction.LogoutAction());
      navigate("/login", { replace: true });
      return;
    }

    // Reset pending landlords view when navigating to Landlords from sidebar
    if (componentName === "Landlords") {
      setPendingLandlordsView(false);
    }

    setActiveComponent(componentName); // Update active component
  };

  return (
    <div className="flex justify-center items-center w-[98%] mx-auto h-screen">
      <div className="w-[20%] h-[97vh]">
        <LeftSection onItemClick={handleItemClick} />
      </div>
      <div className="w-[80%] pl-6 h-screen overflow-scroll scrollbar-hide panelScroll">
        <RightSection
          activeComponent={activeComponent}
          setActiveComponent={setActiveComponent}
          pendingLandlordsView={pendingLandlordsView}
          setPendingLandlordsView={setPendingLandlordsView}
        />
      </div>
    </div>
  );
};

export default Dashboard;
